@if (cardItems().length) {
    <ur-item-slider-or-grid-view
        class="case-stories sir-text-style-title-m-default"
        [title]="
            translations()!.resultPage.caseStoryTitle | interpolate: { application: application() }
        "
        [description]="translations()!.resultPage.caseStoryDescription"
        [items]="cardItems()">
    </ur-item-slider-or-grid-view>

    <sirius-spacer size="large"></sirius-spacer>
}
